module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/writable-browser.js
// module id = 0lxs
// module chunks = 0